import React from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { DPTable, DPEmptyTable, DPPermissionGate } from "Components/DP";
import { Header } from "Components/DP/DPTable/DPTable";
import ProviderBankAccountRow from "./ProviderBankAccountRow/ProviderBankAccountRow";
import BankAccountRow from "./BankAccountRow/BankAccountRow";
import AccountDetailsUserInteraction from "./AccountDetailsUserInteraction/AccountDetailsUserInteraction";
import { DPProviderBankAccount, DPUserBankAccount } from "Shared/types/BankAccounts";
import useStyles from "./styles";

const dpAccountHeaders: Header[] = [
  { label: "Created", align: "right" },
  { label: "Account", align: "right" },
  { label: "Routing", align: "right" },
  { label: "Note", align: "left" },
];
const personalAccountHeaders: Header[] = [
  { label: "Type", align: "left" },
  { label: "Added", align: "right" },
  { label: "Bank", align: "left" },
  { label: "Account", align: "right" },
  { label: "Routing", align: "right" },
  { label: "Note", align: "left" },
];

const ACCOUNT_ON_PAYROLL_NOTE = "This bank account should be on your payroll system";

type AccountDetailsBankingProps = {
  partnerCanceledAt: string | null;
  providerBankAccount: DPProviderBankAccount;
  userBankAccounts: DPUserBankAccount[];
  isDPAccountOnPayroll: boolean;
};

const AccountDetailsBanking = ({
  partnerCanceledAt,
  providerBankAccount,
  userBankAccounts,
  isDPAccountOnPayroll,
}: AccountDetailsBankingProps) => {
  const classes = useStyles();
  const personalAccounts = userBankAccounts || [];
  return (
    <Box>
      <Typography variant="h3">
        <div className={classes.dPIcon} />
        DailyPay Account
      </Typography>
      <DPTable
        id="dailypay-account-details"
        headers={dpAccountHeaders}
        colWidths={[15, 30, 25, 30]}
      >
        {providerBankAccount ? (
          <ProviderBankAccountRow
            providerBankAccount={providerBankAccount}
            note={isDPAccountOnPayroll ? ACCOUNT_ON_PAYROLL_NOTE : ""}
          />
        ) : (
          <DPEmptyTable message="A DailyPay account will be created when the account is active." />
        )}
      </DPTable>
      <br />
      <Typography variant="h3">Personal Accounts</Typography>
      <DPTable
        className={classes.personalAccountDetailsTable}
        id="personal-account-details"
        headers={personalAccountHeaders}
        colWidths={[8, 11.6, 14.6, 21.7, 16, 28]}
      >
        {personalAccounts.length ? (
          personalAccounts.map(account => (
            <BankAccountRow
              key={account.id}
              userBankAccount={account}
              note={account.primary && !isDPAccountOnPayroll ? ACCOUNT_ON_PAYROLL_NOTE : ""}
            />
          ))
        ) : (
          <DPEmptyTable message="Accounts will display here once the user has added them into DailyPay." />
        )}
      </DPTable>
      <DPPermissionGate permissionKeys={["canTerminateEmployee"]}>
        <Grid container item justify="flex-end" className={classes.gridSection}>
          <AccountDetailsUserInteraction
            partnerCanceledAt={partnerCanceledAt}
          />
        </Grid>
      </DPPermissionGate>
    </Box>
  );
};

export default AccountDetailsBanking;
